import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import { FC } from 'react';

type TProps = {
  rows?: number;
};

export const AccountBlockedUsersListSkeleton: FC<TProps> = ({ rows = 4 }) => (
  <Box sx={{ maxWidth: 640 }}>
    {Array.from({ length: rows }).map((_, index) => (
      // oxlint-disable-next-line react/jsx-key, react/no-array-index-key
      <Skeleton key={index} variant="rectangular" height={56} sx={{ mb: '1px' }} />
    ))}
  </Box>
);
